export const RegistryOutsourcesAsync = () => import("./RegistryOutsources.vue");
